import React from 'react';
import { Table } from 'react-bootstrap';

const DataTableViewDesktop = ({ 
  data, 
  columns, 
  rowActions, 
  extraColumns, 
  tableClassName,
  sortConfig,
  onSort,
  disableSorting = false
}) => {
  if (data.length === 0) {
    return (
      <div className="text-center py-5 text-muted d-none d-lg-block">
        <i className="bi bi-search display-6 mb-3"></i>
        <p className="mb-1">No se encontraron resultados</p>
      </div>
    );
  }

  const getUniqueKey = (item, index) => {
    if (item.id_usuario) return `user-${item.id_usuario}-${index}`;
    if (item.id_formulario) return `form-${item.id_formulario}-${index}`;
    return `row-${index}`;
  };

  const renderSortIcon = (column) => {
    if (disableSorting) return null;
    if (!column.sortable) return null;
    
    if (sortConfig.field !== column.key) {
      return <i className="bi bi-arrow-down-up ms-1" style={{ fontSize: '0.8rem', opacity: 0.5 }}></i>;
    }
    return sortConfig.direction === 'asc' 
      ? <i className="bi bi-arrow-up ms-1" style={{ fontSize: '0.8rem' }}></i>
      : <i className="bi bi-arrow-down ms-1" style={{ fontSize: '0.8rem' }}></i>;
  };

  return (
    <div className="d-none d-lg-block">
      <div
        className="table-responsive"
        style={{
          maxHeight: 'calc(90vh - 260px)',
          minHeight: '200px',
          overflowY: 'auto',
          overflowX: 'auto',
          width: '100%'
        }}
      >
        <Table hover className={`align-middle mb-0 ${tableClassName}`} style={{ minWidth: '800px' }}>
          <thead className="table-light sticky-top" style={{ color: '#005793' }}>
            <tr>
              {columns.map(col => (
                <th 
                  key={col.key} 
                  className="py-3"
                  style={{ 
                    cursor: !disableSorting && col.sortable ? 'pointer' : 'default',
                    userSelect: 'none',
                    ...col.style
                  }}
                  onClick={() => {
                    if (!disableSorting && col.sortable) {
                      onSort(col.key);
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    {col.label}
                    {!disableSorting && col.sortable && renderSortIcon(col)}
                  </div>
                </th>
              ))}
              {extraColumns && extraColumns.map((col, index) => (
                <th key={`extra-${index}`} className="py-3 text-center">
                  {col.label || ''}
                </th>
              ))}
              {rowActions && <th className="py-3 text-end">Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={getUniqueKey(item, index)}>
                {columns.map(col => (
                  <td key={`${col.key}-${index}`} style={col.style}>
                    {col.render ? col.render(item) : item[col.key]}
                  </td>
                ))}
                {extraColumns && extraColumns.map((col, colIndex) => (
                  <td key={`extra-${colIndex}-${index}`} className="text-center">
                    {col.render ? col.render(item) : null}
                  </td>
                ))}
                {rowActions && (
                  <td key={`actions-${index}`} className="text-end">
                    {rowActions(item)}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default React.memo(DataTableViewDesktop);